import { Component } from "react";
import { Swiper } from "../../../../utils/guesture";
import * as styles from "../styles.css";
import { StepIndicator } from "../../../atoms/step-indicator";
import { Icon, Icons } from "../../../atoms/icon";
import { cn } from "@discovery/classnames";
import { CarouselItem } from "../../../organisms/mast-head/mobileMastHead";
export class PremiumCarouselM extends Component {
    constructor(props) {
        super(props);
        this.componentDidMount = () => {
            this.setTimer();
        };
        this.setTimer = () => {
            if (this.props.loop) {
                this._timer = window.setInterval(() => this.setCurrent(this.state.currentStep + 1), this.props.autoplay);
            }
        };
        this.resetTimer = () => {
            if (this.props.loop) {
                clearInterval(this._timer);
                this.setTimer();
            }
        };
        this.onSwipe = (e) => {
            if (this.props.data.length > 1) {
                if (e === "swiped-left") {
                    this.addCurrent();
                    this.resetTimer();
                }
                else if (e === "swiped-right") {
                    this.subCurrent();
                    this.resetTimer();
                }
            }
        };
        this.onStepIndicatorClick = (id) => {
            this.setCurrent(id + 1);
            this.resetTimer();
        };
        this.onLeftClick = () => {
            this.subCurrent();
            this.resetTimer();
        };
        this.onRightClick = () => {
            this.addCurrent();
            this.resetTimer();
        };
        this.renderItems = () => {
            const { premium, data } = this.state;
            const { premiumPackages } = this.props;
            if (data) {
                const res = data.map((item, index) => {
                    return (React.createElement(CarouselItem, Object.assign({}, item, { premium: premium, premiumPackages: premiumPackages, key: index, isPremiumCarousel: true, index: index })));
                });
                return res;
            }
            return;
        };
        this.state = {
            currentStep: 1,
            translateValue: -92,
            transitionAnimation: "transform ease-out 0.45s",
            data: props.data.length > 0
                ? [props.data[props.data.length - 1], ...props.data, props.data[0]]
                : [],
            premium: true,
        };
        this._timer = 0;
    }
    componentWillUnmount() {
        if (this._timer)
            clearInterval(this._timer);
    }
    addCurrent() {
        this.setCurrent(this.state.currentStep + 1);
    }
    subCurrent() {
        this.setCurrent(this.state.currentStep - 1);
    }
    setCurrent(id) {
        const images = this.state.data || [];
        if (this.props.loop) {
            id = (id + images.length) % images.length;
        }
        this.setState({
            currentStep: id,
            translateValue: -(id * 82.5 + id * 8 + id),
            transitionAnimation: "transform ease-out 0.45s",
        }, () => {
            if (this.state.currentStep === images.length - 1) {
                //for circular right
                setTimeout(() => {
                    this.setState({
                        currentStep: 1,
                        transitionAnimation: "none",
                        translateValue: -92,
                    });
                }, 450);
            }
            else if (this.state.currentStep === 0) {
                //for circular left
                setTimeout(() => {
                    this.setState({
                        currentStep: images.length - 2,
                        transitionAnimation: "none",
                        translateValue: -((images.length - 2) * 75),
                    });
                }, 450);
            }
        });
    }
    render() {
        return (React.createElement(React.Fragment, null, window.innerWidth <= 700 && (React.createElement("div", { className: styles.wrap },
            React.createElement(Swiper, { onSwipe: this.onSwipe },
                React.createElement("div", { className: styles.carouselContainer },
                    React.createElement("div", { className: cn(styles.arrow, styles.leftArrow), onClick: this.onLeftClick },
                        React.createElement(Icon, { type: Icons.AngleLeftIcon, color: "#FFF", className: styles.arrowIcon })),
                    React.createElement("div", { className: styles.carouselItemWrapper, style: {
                            transform: `translateX(${this.state.translateValue}%)`,
                            transition: this.state.transitionAnimation,
                        } }, this.renderItems()),
                    React.createElement("div", { className: cn(styles.arrow, styles.rightArrow), onClick: this.onRightClick },
                        React.createElement(Icon, { type: Icons.AngleRightIcon, color: "#FFF", className: styles.arrowIcon })))),
            this.props.data.length > 1 && (React.createElement(StepIndicator, { maxStep: this.props.data.length, currentStep: this.state.currentStep && this.state.currentStep - 1, onClick: this.onStepIndicatorClick, containerStyle: styles.containerStyle }))))));
    }
}

